import { Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout.component';
import { DashboardRoutes } from '../../features/dashboard/dashboard.routes';
import { TrackingRoutes } from '../../features/telematics/tracking/tracking.routes';
import { googleMapsResolver } from '../auth/resolvers/google-maps.resolver';

export const mainRoutes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    resolve: { googleMapsLoaded: googleMapsResolver },
    children: [
      ...DashboardRoutes,
      ...TrackingRoutes,
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
    title: 'Safety | ADROIT',
  },
];
